<template>
  <div v-if="status" :class="['status-order', status]">{{ showText ? showText : orderStatusValue[status].text }}</div>
  <div v-else class="w-100 text-center">---</div>
</template>

<script>
export default {
  props: ["status","showText"],
  data() {
    return {
      orderStatusValue: {
        LISTING: {
          text: "Nháp",
        },
        DRAFT: {
          text: "Nháp",
        },
        NEW: {
          text: "Nháp",
        },
        COMPLETE: {
          text: "Hoàn thành",
        },
        SUCCESS: {
          text: "Thành công",
        },
        TIMEOUT: {
          text: "Đã hủy",
        },
        CANCEL: {
          text: "Đã hủy",
        },
        PROCESSING: {
          text: "Đang tiến hành",
        },
        FAILED: {
          text: "Thất bại"
        },
      },
    }
  },
  methods: {
  },
  // computed: {
  //   hasDefaultSlot () {
  //     return !!this.$slots.default
  //   },
  // }
}
</script>

<style lang="scss" scoped>
.status-order {
    padding: 4px 12px;
    background: #ecf0fe;
    border-radius: 100px;
    font-weight: bold;
    width: fit-content;
    text-align: center;
  }
  .status-order.INFO {
    color: #515E89;
    background-color: #EBEBEB;
  }
  .status-order.DRAFT {
    color: #f49300;
    background-color: #fff9f4;
  }
  .status-order.LISTING {
    color: #f49300;
    background-color: #fff9f4;
  }
  .status-order.NEW {
    color: #f49300;
    background-color: #fff9f4;
  }
  .status-order.COMPLETE {
    color: #3dbb65;
    background-color: #f2fcf5;
  }
  .status-order.SUCCESS {
    color: #3dbb65;
    background-color: #f2fcf5;
  }
  .status-order.CANCEL {
    color: #eb3b5b;
    background-color: #fef3f5;
  }
  .status-order.FAILED {
    color: #eb3b5b;
    background-color: #fef3f5;
  }
  .status-order.TIMEOUT {
    color: #eb3b5b;
    background-color: #fef3f5;
  }
  .status-order.PROCESSING {
    color: #6587F8;
    background-color: #ECF0FE;
  }
</style>